
import React from "react";

interface CourseFormatProps {
  format_description?: string | null;
}

const CourseFormat = ({ format_description }: CourseFormatProps) => (
  <div className="mb-10">
    <h2 className="text-xl font-semibold mb-3">Kursuse formaat</h2>
    <p className="text-gray-700">{format_description || "-"}</p>
  </div>
);

export default CourseFormat;
